
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'NavLinkComponent',
  props: {
      title: {
          type: String,
          required: true
      },
      icon: {
          type: String,
          required: true
      },
      name: {
          type: String,
          required: true
      }
  },
})
